import React from "react";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import DataTable from "../../components/Elements/DataTable/DataTable";
import { fetchCarriersAdmin } from "../../services/CarrierService";

// Always visible table columns
const alwaysVisibleColumns = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "api_token", label: "API Token" },
  { key: "rate", label: "Rate", type: "text" },
  { key: "cutoff", label: "Cutoff", type: "text" },
];

// Columns that user can toggle on/off
const optionalColumns = [{ key: "id", label: "ID" }];

// Sort options for table header
const sortOptions = [
  { value: "name", label: "Name" },
  { value: "email", label: "Email" },
  { value: "id", label: "ID" },
];

// Filter definitions for table toolbar
const filterDefinitions = [
  { key: "name", label: "Name", type: "text" },
  { key: "email", label: "Email", type: "text" },
  { key: "owner_id", label: "Owner ID", type: "text" },
];

const AdminCarriers = () => {
  // Adapter for DataTable fetch signature
  const fetchDataFn = (params) => fetchCarriersAdmin(params);

  return (
    <div className="admin-carriers-page">
      <PageHeader title="Carriers" description="View all carriers" />

      <DataTable
        tableId="admin-carriers"
        fetchDataFunction={fetchDataFn}
        columns={alwaysVisibleColumns}
        optionalColumns={optionalColumns}
        sortOptions={sortOptions}
        filterDefinitions={filterDefinitions}
        defaultSortBy="name"
        itemKey="id"
        rowActions={[]}
        showCheckboxes={false}
        showFilters={true}
        showPageSize={true}
      />
    </div>
  );
};

export default AdminCarriers;
